import { create } from "zustand";

type EventStore = {
	choice: "accepted" | "maybe" | "declined" | null;
	setChoice: (choice: "accepted" | "maybe" | "declined" | null) => void;
	clearChoice: () => void;
};

export const useEventStore = create<EventStore>((set) => ({
	choice: null,
	setChoice: (choice) => set({ choice }),
	clearChoice: () => set({ choice: null }),
}));
